<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h5 class="mt-1 mb-3">Lista de Ranfs</h5>
            <div class="row">
              <div class="col-12">
                <TableRanfs/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "@/router/layouts/main";
import appConfig from "@/dados/app.config.json";
import TableRanfs from '@/router/views/ranfs/components/table-ranfs'
import PageHeader from "@/components/page-header";

export default {
  page: {
    title: "Lista de Ranf",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    TableRanfs
  },
  data() {
    return {
      title: "Registro Auxiliar de Nota Fiscal de Serviço (RANFS)",
      items: [
        {
          text: 'Painel',
          href: '/painel',
        },
        {
          text: 'Ranfs',
          active: true,
        },
      ],
    };
  },
  computed: {
    empresa: {
      get: function () {
        return this.$store.state.auth.currenEmpresa;
      },
    },
  },
  created() {
    /*
    let tipoEmpresa = parseInt(this.empresa.pes_tipopessoa);
    if (tipoEmpresa === 4) {
      this.$toast.error("Esta empresa não tem permissão para a utilização deste recurso")
      this.$router.push({name: 'painel'})
    } */
  },
};
</script>


